export const EventType2 = {
    Playback: "playback",
    Sender: "sender",
    Relay1: "relay1",
    Relay2: "relay2",
    Audio: "audio"
}

export const EventType1 = {
    Automation: "automation",
    ControlledBy: "control",
    //Always: "always",
    // ThirdParty: "third",
}

export const ConfigurationMap = [
    {id: "auto", name: "Automation", variant: "primary"},
    {id: "ctrl", name: "Controlled By", variant: "primary"},
    {id: "third", name: "Third-Party", variant: "primary"},
    {id: "undef", name: "Undefined", variant: "secondary"},
]

// Not used anymore
// export const RelayMap = {
//     RelayNano: 1,
//     RelayMulti: 4
// }

export const RelayAction = [
    {id: 0, name: "Switch Off"},
    {id: 1, name: "Switch On"},
    {id: 2, name: "Impulse"},
]

export const DeviceProject = {
    NanoEth: "brd-nano-eth",
    MicroEth: "brd-micro-eth",
    StandardEth: "brd-std-eth",
    RelayNano: "ab-relay-nano",
    RelayMulti: "ab-relay-multi",
    PlayerNano: "ab-player-nano",
    AudioNano: "ab-audio-nano",
    ButtonNano: "ab-button-nano",
    SensorTemperature: "ab-sensor-temp",
    SensorHumidity: "ab-sensor-humidity",
}

export const ProjectMap = [
    {
        project: DeviceProject.StandardEth, configure: [
            {
                title: "Playback",
                path: "playback",
                event_type2: EventType2.Playback,
                always: true,
                overlapFilters: [EventType2.Playback, EventType2.Sender],
                advPlayback: true
            },
            {title: "Sender", path: "sender", event_type2: EventType2.Sender, always: true, overlapFilters: [EventType2.Playback, EventType2.Sender], advPlayback: false}
        ], connection: "ethernet"
    },
    {
        project: DeviceProject.NanoEth, configure: [
            {title: "Playback", path: "playback", event_type2: EventType2.Playback, always: true, overlapFilters: [EventType2.Playback], advPlayback: false},
        ], connection: "ethernet"
    },
    {
        project: DeviceProject.MicroEth, configure: [
            {title: "Playback", path: "playback", event_type2: EventType2.Playback, always: true, overlapFilters: [EventType2.Playback], advPlayback: true},
        ], connection: "ethernet"
    },
    {
        project: DeviceProject.PlayerNano, configure: [
            {title: "Playback", path: "playback", event_type2: EventType2.Playback, always: true, overlapFilters: [EventType2.Playback], advPlayback: false},
        ], connection: "wifi"
    },
    {
        project: DeviceProject.AudioNano, configure: [
            {title: "Playback", path: "playback", event_type2: EventType2.Playback, always: true, overlapFilters: [EventType2.Playback], advPlayback: false},
        ], connection: "wifi"
    },
    {
        project: DeviceProject.ButtonNano, configure: [], connection: "wifi"
    },
    {
        project: DeviceProject.RelayNano, configure: [
            {title: "Relay 1", index: 1, path: "relay1", event_type2: EventType2.Relay1, always: false, overlapFilters: [EventType2.Relay1], advPlayback: false},
            // {title: "Relay 2", index: 2, path: "relay2", event_type2: EventType2.Relay2, always:false, overlapFilters: [EventType2.Relay2]},
        ], connection: "wifi"
    },
    {
        project: DeviceProject.RelayMulti, configure: [
            {title: "Relay 1", path: "relay1", event_type2: EventType2.Relay1, always: false},
            {title: "Relay 2", path: "relay2", event_type2: EventType2.Relay2, always: false},
            {title: "Relay 3", path: "relay3", event_type2: EventType2.Relay1, always: false},
            {title: "Relay 4", path: "relay4", event_type2: EventType2.Relay1, always: false}
        ], connection: "wifi"
    },
]

export const PaymentMethods = {
    Bank: "bank",
    PayPal: "paypal",
    Bitcoin: "bitcoin"
}

export const OrderStatus = {
    Draft: "draft",
    Submitted: "submitted",
    Paid: "paid",
    Shipping: "shipping",
    Delivered: "delivered",
    Cancelled: "cancelled",
    Refunded: "refunded"
}